import { Button, ColorsEnum, Icon, Text } from '@shared/widgets';
import CopyIcon from '@assets/icons/copy.svg';

interface ItemProps {
  name: string;
  value: string;
}

export const Item = (props: ItemProps) => {
  const handleCopy = () => navigator.clipboard.writeText(props.value);

  return (
    <div className='flex items-center justify-between my-3 first:my-0'>
      <div>
        <Text size='sm' color={ColorsEnum.Secondary}>
          {props.name}
        </Text>
        <Text className='max-w-52 pr-3 break-words' weight='semibold' size='sm'>
          {props.value}
        </Text>
      </div>
      <div className='flex gap-2 items-center'>
        <Button color='icon' onClick={handleCopy}>
          <Icon icon={<CopyIcon />} color='primary' />
        </Button>
      </div>
    </div>
  );
};
